module.exports = __webpack_public_path__ + "4e104806f338d9ab724990ca466c2aa8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_5.jpg
// module id = 1680
// module chunks = 5